export default "__VITE_ASSET__etrGryli__"